export default "__VITE_ASSET__45a6ef30__"